import React from 'react';
import FullHeight from './full-height';
import styled from 'styled-components';

interface CenterProps {
  children: React.ReactNode;
  maxWidth?: number;
  fullHeight?: boolean;
  dark?: boolean;
  style?: React.CSSProperties;
}

const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  ${({ dark }) => (dark ? 'background-color: #333;' : null)}
`;

const Center: React.FC<CenterProps> = ({
  children,
  maxWidth,
  fullHeight = false,
  dark = false,
  style = {},
}) => {
  const Wrapper = fullHeight ? FullHeight : React.Fragment;
  return (
    <Wrapper>
      <CenterContainer dark={dark} style={{...style}}>
        {maxWidth && <div style={{ maxWidth }}>{children}</div>}
        {!maxWidth && children}
      </CenterContainer>
    </Wrapper>
  );
};

export default Center;
